import { Button } from "atoms/button/Button";
import { Checkbox } from "atoms/checkbox/Checkbox";

import { QuizStepProps } from "../useQuestionnaire";

export const MedicalHistory = (props: QuizStepProps) => {
  const hasError = !!props.errors?.MedicalHistory;

  const handleCheckChange = (checked: boolean, value: string) => {
    if (!props.data.MedicalHistory) {
      props.data.MedicalHistory = [];
    }
    if (!checked) {
      const newMedicalHistory = (props.data.MedicalHistory as string[]).filter(
        (v: string) => v !== value
      );
      props.handleStepData("MedicalHistory", newMedicalHistory);
    } else if (value === "None") {
      props.handleStepData("MedicalHistory", ["None"]);
    } else if (props.data.MedicalHistory.includes("None")) {
      props.handleStepData("MedicalHistory", [value]);
    } else {
      props.handleStepData("MedicalHistory", [
        ...props.data.MedicalHistory,
        value,
      ]);
    }
  };

  return (
    <div className="flex h-full flex-col">
      <div className="pb-8 font-serif text-h3">
        Do any of the following apply to you?
      </div>
      <div>
        <div className="flex flex-col items-start">
          {options.map((option) => (
            <div key={option.value} className="w-full">
              <Checkbox
                textStyle="text-bold2"
                checked={props.data.MedicalHistory?.includes(option.value)}
                onChange={(e) => handleCheckChange(e, option.value)}
                label={option.label}
              />
              <div className="w-full border-b border-gray-100 pt-1"></div>
            </div>
          ))}
        </div>
      </div>
      <div hidden={!hasError}>
        <p className="mt-2 text-sm text-red">
          Please select at least one option.
        </p>
      </div>
      <div className="mt-auto">
        <Button onClick={props.next} fullWidth>
          Next Question
        </Button>
      </div>
    </div>
  );
};

const options = [
  {
    label: "Gallbladder disease",
    value: "GallbladderDisease",
  },
  {
    label: "Alcohol/substance use disorder",
    value: "AlchoholSubstanceDisorder",
  },
  {
    label: "Hypertension (high blood pressure)",
    value: "Hypertension",
  },
  {
    label: "Seizures",
    value: "Seizures",
  },
  {
    label: "Glaucoma",
    value: "Glaucoma",
  },
  {
    label: "Sleep apnea",
    value: "SleepApnea",
  },
  {
    label: "Type 2 diabetes (not on insulin)",
    value: "Type2DiabetesNoInsulin",
  },
  {
    label: "Type 2 diabetes (on insulin)",
    value: "Type2DiabetesYesInsulin",
  },
  {
    label: "Type 1 diabetes",
    value: "Type1Diabetes",
  },
  {
    label: "Diabetic retinopathy (diabetic eye disease)",
    value: "DiabeticRetinopathy",
  },
  {
    label: "Pancreatitis",
    value: "Pancreatitis",
  },
  {
    label:
      "Thyroid cyst/nodule, thyroid cancer, medullary thyroid carcinoma, or multiple endocrine neoplasia syndrome type 2",
    value: "ThyroidCystOrCancer",
  },
  {
    label: "Gout",
    value: "Gout",
  },
  {
    label: "High cholesterol or triglycerides",
    value: "HighCholesterol",
  },
  {
    label: "Depression",
    value: "Depression",
  },
  {
    label: "Head injury",
    value: "Headinjury",
  },
  {
    label: "Tumor/infection in brain/spinal cord",
    value: "TumorOnBrainOrSpinal",
  },
  {
    label: "Low sodium",
    value: "LowSodium",
  },
  {
    label: "Liver disease, including fatty liver",
    value: "LiverDisease",
  },
  {
    label: "Kidney disease",
    value: "KidneyDisease",
  },
  {
    label: "Elevated resting heart rate (tachycardia)",
    value: "ElevatedRestingHR",
  },
  {
    label: "Coronary artery disease or heart attack/stroke in last 2 years",
    value: "CoronaryArteryStrokeOrHA",
  },
  {
    label: "Congestive heart failure",
    value: "HeartFailure",
  },
  {
    label: "QT prolongation or other heart rhythm disorder",
    value: "QTHeartRhythm",
  },
  {
    label: "Hospitalization within the last 1 year",
    value: "HospitalizedInYear",
  },
  {
    label: "Human immunodeficiency virus (HIV)",
    value: "HIV",
  },
  {
    label: "Acid reflux",
    value: "AcidReflux",
  },
  {
    label: "Asthma/reactive airway disease",
    value: "Asthma",
  },
  {
    label: "Urinary stress incontinence",
    value: "Incontinence",
  },
  {
    label: "Polycystic ovarian syndrome (PCOS)",
    value: "PCOS",
  },
  {
    label: "Clinically proven low testosterone",
    value: "LowTestosterone",
  },
  {
    label: "Osteoarthritis",
    value: "Osteoarthritis",
  },
  {
    label: "Constipation",
    value: "Constipation",
  },
  {
    label: "Hyperemesis gravidarum (nausea/vomiting in pregnancy)",
    value: "HyperemesisGravidarum",
  },
  {
    label: "None of the above",
    value: "None",
  },
];
